/**
 * 새 배포 감지 시 새로고침 유도 배너.
 * 디자인 시스템 미정 — 기본 Tailwind 스타일만 쓴다.
 */
import { useAppVersionCheck } from '@/shared/hooks/useAppVersionCheck';
import React from 'react';

export const VersionUpdateBanner: React.FC = () => {
  const { hasUpdate } = useAppVersionCheck();

  if (!hasUpdate) return null;

  return (
    <div
      role="status"
      className="fixed right-4 bottom-4 z-[9999] flex items-center gap-3 rounded-lg bg-gray-900 px-4 py-3 text-sm text-white shadow-lg"
    >
      <span>새 버전이 배포되었습니다.</span>
      <button
        type="button"
        className="rounded-md bg-white px-3 py-1 text-gray-900 hover:bg-gray-100"
        onClick={() => window.location.reload()}
      >
        새로고침
      </button>
    </div>
  );
};
